import React from 'react';
import Icon, { COLORS, ICONS } from './icon';
import { handleClickJacking } from '../../utils/utils';
import Switch from './switch';

export default function IconPreviews() {
    const keys = Object.keys(ICONS).sort();

    handleClickJacking();

    const getIcons = () => {
        return keys.map((key: string) => {
            // @ts-ignore
            const name = ICONS[key];
            return (
                <div className="icon-previews-preview" key={key}>
                    <Icon
                        name={name}
                        size={50}
                        color={COLORS.WHITE}
                    />
                    <Icon
                        name={name}
                        size={50}
                        color={COLORS.WHITE}
                        forcev3={true}    
                    />
                    <div className="icon-name">{key}</div>
                </div>
            )
        });
    };

    const [compact, setCompact] = React.useState(true);

    return (
        <div className={`icon-previews ${compact ? 'compact' : ''}`}>
            <div style={{
                width: '100%',
                padding: '16px',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 'bold',
            }}>
                Compact View
                &nbsp;&nbsp;
                <Switch on={compact} onChange={() => setCompact(prev => !prev)} />
            </div>
            {getIcons()}
        </div>
    )
}